<p-toast
  [ngClass]="{ 'disable-color': disableColor }"
  [position]="position!"
  [key]="key!"
  [life]="appConfig.toastrDuration"
  [preventDuplicates]="false"
  [preventOpenDuplicates]="false"></p-toast>
